import {negativeCircleFilledSvg as Icon__small__negativeCircleFilledSvg} from '../Icon__small/Icon__small--negativeCircleFilled.js';

export var negativeCircleFilled = {
  name: 'negativeCircleFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__negativeCircleFilledSvg,
};
